module.exports = __webpack_public_path__ + "static/media/dashboardDark.06a608a8.png";